var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-logout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF2F5",
    transform: "translate(3.000000, 4.375000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625,2.25 C5.953125,2.25 6.22265625,2.14453125 6.43359375,1.93359375 L6.43359375,1.93359375 C6.64453125,1.72265625 6.75,1.453125 6.75,1.125 C6.75,0.796875 6.64453125,0.52734375 6.43359375,0.31640625 C6.22265625,0.10546875 5.953125,0 5.625,0 L3.375,0 C2.4140625,0.0234375 1.6171875,0.3515625 0.984375,0.984375 C0.3515625,1.6171875 0.0234375,2.4140625 0,3.375 L0,12.375 C0.0234375,13.3359375 0.3515625,14.1328125 0.984375,14.765625 C1.6171875,15.3984375 2.4140625,15.7265625 3.375,15.75 L5.625,15.75 C5.953125,15.75 6.22265625,15.6445312 6.43359375,15.4335938 C6.64453125,15.2226562 6.75,14.953125 6.75,14.625 C6.75,14.296875 6.64453125,14.0273438 6.43359375,13.8164062 C6.22265625,13.6054688 5.953125,13.5 5.625,13.5 L3.375,13.5 C3.046875,13.5 2.77734375,13.3945312 2.56640625,13.1835938 C2.35546875,12.9726562 2.25,12.703125 2.25,12.375 L2.25,3.375 C2.25,3.046875 2.35546875,2.77734375 2.56640625,2.56640625 C2.77734375,2.35546875 3.046875,2.25 3.375,2.25 L5.625,2.25 Z M17.7539062,8.47265625 C17.9179688,8.30859375 18,8.109375 18,7.875 C18,7.640625 17.9179688,7.44140625 17.7539062,7.27734375 L12.6914062,2.49609375 C12.4101562,2.26171875 12.1054688,2.203125 11.7773438,2.3203125 C11.4492188,2.484375 11.2734375,2.7421875 11.25,3.09375 L11.25,5.625 L6.75,5.625 C6.421875,5.625 6.15234375,5.73046875 5.94140625,5.94140625 C5.73046875,6.15234375 5.625,6.421875 5.625,6.75 L5.625,9 C5.625,9.328125 5.73046875,9.59765625 5.94140625,9.80859375 C6.15234375,10.0195312 6.421875,10.125 6.75,10.125 L11.25,10.125 L11.25,12.65625 C11.2734375,13.0078125 11.4492188,13.265625 11.7773438,13.4296875 C12.1054688,13.546875 12.4101562,13.4882812 12.6914062,13.2539062 L17.7539062,8.47265625 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic-logout.ce1a2b101833e7c54917d9bfc445c396.svg";
export { ForwardRef as ReactComponent };